// extracted by mini-css-extract-plugin
export default {"container":"StripeReturnPage_container__jjLgh","icon":"StripeReturnPage_icon__iUI5P","formButton":"StripeReturnPage_formButton__cFBvX"};